import { render, staticRenderFns } from "./ExpandableAlert.vue?vue&type=template&id=150bf8b3&scoped=true"
import script from "./ExpandableAlert.vue?vue&type=script&lang=js"
export * from "./ExpandableAlert.vue?vue&type=script&lang=js"
import style0 from "./ExpandableAlert.vue?vue&type=style&index=0&id=150bf8b3&prod&lang=css"
import style1 from "./ExpandableAlert.vue?vue&type=style&index=1&id=150bf8b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150bf8b3",
  null
  
)

export default component.exports